export const ANOMALY_DIRECTION = {
  BOTH: "BOTH",
  ABOVE: "ABOVE",
  BELOW: "BELOW",
} as const

export const ANOMALY_DIRECTIONS = [
  ANOMALY_DIRECTION.BOTH,
  ANOMALY_DIRECTION.ABOVE,
  ANOMALY_DIRECTION.BELOW,
] as const

export type AnomalyDirection = (typeof ANOMALY_DIRECTIONS)[number]

export const METRIC_BASELINE_DETECTION_METHODS = ["EWMA"] as const

export type MetricBaselineDetectionMethod =
  (typeof METRIC_BASELINE_DETECTION_METHODS)[number]

// Detector-specific config types — add new interfaces here per detector
export interface EWMAConfig {
  time_constant_seconds: number
}

// Union of all detector configs — extend when adding new detectors
export type DetectorConfig = EWMAConfig | Record<string, unknown>

export const TIME_CONSTANT_PRESETS = [
  { value: 86400, label: "1 day" },
  { value: 604800, label: "7 days" },
  { value: 1296000, label: "15 days" },
  { value: 2592000, label: "30 days" },
  { value: 5184000, label: "60 days" },
  { value: 7776000, label: "90 days" },
  { value: 10368000, label: "120 days" },
] as const

export const DIRECTION_OPTIONS = [
  { value: ANOMALY_DIRECTION.BOTH, label: "Both directions" },
  { value: ANOMALY_DIRECTION.ABOVE, label: "Above only" },
  { value: ANOMALY_DIRECTION.BELOW, label: "Below only" },
] as const

export const DEFAULT_SIGMA_THRESHOLD = 2.0
export const DEFAULT_DIRECTION: AnomalyDirection = ANOMALY_DIRECTION.BOTH

export const DEFAULT_EWMA_CONFIG: EWMAConfig = {
  time_constant_seconds: 604800,
}
